import React, { Component } from 'react';
import { getPresence } from './RET.service.ts';
import { withTranslation } from 'react-i18next';
import { TextStyle } from '@ticketmaster/global-design-system';
import styles from './RET.module.scss';
import { T } from '@/v2/helpers/i18n';

type Props = {
  token: string;
  id: string;
} & T;
type State = {};

class RET extends Component<Props, State> {
  state: { renderer: any } = {
    renderer: null,
  };

  async componentDidMount() {
    const { token, id } = this.props;
    const Presence = await getPresence();
    const renderer = new Presence.SecureEntryView({ selector: `#${id}` });
    renderer.setPDF417Subtitle(false);
    renderer.setToken(token);

    this.setState({
      renderer,
    });
  }

  componentDidUpdate(prev: { token: string }) {
    const { renderer } = this.state;
    const { token } = this.props;
    if (renderer && token !== prev.token) {
      renderer.setToken(token);
    }
  }

  render() {
    const { id, t } = this.props;
    return (
      <section>
        <div id={id} className={styles.retBarcodeContainer} />
        {<TextStyle.Etna>{t('WALLET.TICKETS.SCREENSHOTS_WILL_NOT_GET_YOU_IN')}</TextStyle.Etna>}
      </section>
    );
  }
}

export default withTranslation('translation')(RET);
